import React, { FC } from 'react';
import { SpinLoading, Space  } from 'antd-mobile'


const Loading: FC = () => <Space justify='center' block style={{paddingTop: '3rem'}}><SpinLoading /></Space>

export default Loading;